module.exports = __webpack_public_path__ + "img/34_34.8e4b8c7d.png";